(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["libelula-upsell-card"] && !Shopify.designMode) return;
  try {
    if (!window.libelulaUpsellInitialized) {
    window.libelulaUpsellInitialized = true;

    const routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    const resetUpsellButtons = () => {
      document.querySelectorAll('[data-la-upsell-add]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.defaultLabel;
        const status = button.closest('[data-la-upsell-card]').querySelector('[data-la-upsell-status]');
        if (status) status.textContent = '';
      });
    };

    resetUpsellButtons();
    window.addEventListener('pageshow', resetUpsellButtons);

    const requestCart = async () => {
      const response = await fetch(`${routeRoot}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      return response.json();
    };

    const addVariant = async (variantId) => {
      const response = await fetch(`${routeRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('add');
      return response.json();
    };

    const removeLine = async (lineKey) => {
      const response = await fetch(`${routeRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      if (!response.ok) throw new Error('change');
      return response.json();
    };

    const refreshMiniCarts = async (cart) => {
      const forms = document.querySelectorAll('[data-cart-form="mini-cart"]');
      if (!forms.length) return;

      const sectionForm = Array.from(forms).find((form) => form.closest('.shopify-section'));
      const section = sectionForm ? sectionForm.closest('.shopify-section') : null;
      if (!section || !section.id) throw new Error('section');

      const sectionId = encodeURIComponent(section.id.replace('shopify-section-', ''));
      const response = await fetch(`${routeRoot}?section_id=${sectionId}&_=${Date.now()}`, {
        cache: 'no-store',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('section');

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacementForm = parsed.querySelector('[data-cart-form="mini-cart"]');
      if (!replacementForm) throw new Error('section');

      forms.forEach((form) => {
        ['.js-cart_items', '.js-cart_discounts', '.js-cart_subtotal', '.js-cart_savings', '.js-mini-cart-upsell'].forEach((selector) => {
          const current = form.querySelector(selector);
          const replacement = replacementForm.querySelector(selector);
          if (current && replacement) current.replaceWith(replacement.cloneNode(true));
          if (current && !replacement) current.remove();
        });
      });

      document.querySelectorAll('.cart_count').forEach((count) => {
        count.textContent = cart.item_count;
      });
      document.querySelectorAll('.js-empty-cart__message').forEach((message) => {
        message.classList.toggle('hidden', cart.item_count > 0);
      });
      forms.forEach((form) => {
        form.classList.toggle('hidden', cart.item_count === 0);
        form.dataset.totalDiscount = cart.total_discount;
      });
    };

    const trackUpsell = (eventName, button) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        upsell_placement: button.dataset.upsellPlacement,
        ecommerce: {
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'CLP',
          value: Number(button.dataset.upsellPrice || 0) / 100,
          items: [{
            item_id: button.dataset.upsellProductId,
            item_name: button.dataset.upsellProductTitle,
            item_variant: button.dataset.upsellVariantId,
            price: Number(button.dataset.upsellPrice || 0) / 100,
            quantity: 1
          }]
        }
      });
    };

    let miniCartRefreshTimer;
    const scheduleMiniCartRefresh = () => {
      window.clearTimeout(miniCartRefreshTimer);
      miniCartRefreshTimer = window.setTimeout(async () => {
        try {
          const cart = await requestCart();
          await refreshMiniCarts(cart);
        } catch (error) {
          return;
        }
      }, 900);
    };

    document.addEventListener('change', (event) => {
      const variantOption = event.target.closest('[data-la-upsell-variant]');
      if (variantOption) {
        const card = variantOption.closest('[data-la-upsell-card]');
        const button = card.querySelector('[data-la-upsell-add]');
        const currentPrice = card.querySelector('[data-la-upsell-current-price]');
        const comparePrice = card.querySelector('[data-la-upsell-compare-price]');
        const saving = card.querySelector('[data-la-upsell-saving]');
        const choiceSaving = variantOption.closest('.la-upsell__choice').querySelector('small');

        button.dataset.upsellVariantId = variantOption.dataset.variantId;
        button.dataset.upsellPrice = variantOption.dataset.price;
        button.dataset.upsellVariantTitle = variantOption.dataset.variantTitle;
        currentPrice.textContent = variantOption.dataset.money;

        if (Number(variantOption.dataset.compareAtPrice) > Number(variantOption.dataset.price)) {
          comparePrice.textContent = variantOption.dataset.compareAtMoney;
          comparePrice.hidden = false;
          saving.textContent = choiceSaving ? choiceSaving.textContent : '';
          saving.hidden = !choiceSaving || Number(variantOption.dataset.saving) <= 0;
        } else {
          comparePrice.hidden = true;
          saving.textContent = '';
          saving.hidden = true;
        }
      }

      if (event.target.matches('[data-cart-quantity-input="mini-cart"]')) scheduleMiniCartRefresh();
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-remove-item="mini-cart"], [data-cart-form="mini-cart"] .js-change-quantity')) {
        scheduleMiniCartRefresh();
      }
    });

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-la-upsell-add]');
      if (!button || button.disabled) return;

      const status = button.closest('[data-la-upsell-card]').querySelector('[data-la-upsell-status]');
      const action = button.dataset.upsellAction;
      const defaultLabel = button.dataset.defaultLabel;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = button.dataset.addingLabel;
      status.textContent = button.dataset.addingLabel;
      trackUpsell('upsell_click', button);

      try {
        const added = await addVariant(button.dataset.upsellVariantId);
        if (action === 'upgrade' && button.dataset.sourceLineKey) {
          try {
            await removeLine(button.dataset.sourceLineKey);
          } catch (error) {
            const addedItem = added.items && added.items[0];
            if (addedItem && addedItem.key) await removeLine(addedItem.key);
            throw error;
          }
        }

        const cart = await requestCart();
        trackUpsell(action === 'upgrade' ? 'upsell_upgrade' : 'upsell_add_to_cart', button);
        button.textContent = button.dataset.addedLabel;
        status.textContent = button.dataset.addedLabel;
        button.removeAttribute('aria-busy');

        if (button.dataset.upsellPlacement === 'cart') {
          window.location.reload();
          return;
        }

        await refreshMiniCarts(cart);
        document.querySelectorAll('.cart-container').forEach((container) => container.classList.add('active_link'));
        window.setTimeout(() => {
          if (!button.isConnected) return;
          button.disabled = false;
          button.textContent = defaultLabel;
          status.textContent = '';
        }, 1400);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = button.dataset.errorLabel;
        status.textContent = button.dataset.errorLabel;
        window.setTimeout(() => {
          button.textContent = defaultLabel;
        }, 2400);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
